import { useEffect, useRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from '../../../node_modules/react-router-dom/dist/index';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
export default function ForgotPassword() {
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ newPassword: '', confirmPassword: '' });
    const [showPassword, setShowPassword] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const ForgetToken = queryParams.get('ForgetToken');
    const UserCode = queryParams.get('UserCode');

    const handleSubmit = async () => {
        setIsLoading(true);
        const data = {
            ForgetToken: ForgetToken,
            UserCode: UserCode,
            NewPassword: user.newPassword,
            ConfirmPassword: user.confirmPassword,
            Source: 'web'
        }
        let res = await ApiCall(`/api/UserLogin/UpdateForgotPassword`, data)
        if (res.status === 'SUCCESS') {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            navigate('/login')

        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };

   
   
    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };

    useEffect(() => {
        inputrefs.current['txtNewPassword'].focus()
      
    }, [])

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" style={{ opacity: '0.88' }} >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            <img src="./assets/img/TruckHiringLogo.png" className='img1' alt="..." style={{ display: "flex" }} />
                        </div>
                        <div className="innerlogindiv ">
                            <h5 className=" text-center" style={{ textShadow: '2px 2px 2px #c7ad79' }}>
                                <h5 className=" text-center fw-bold" style={{ color: "#74531f", }}><span> Welcome To Grand Slam </span>
                                    <br /><span className='fw-bold ' style={{ color: "#74531f", marginTop: '4px', display: 'inline-block' }} >Client Portal</span>
                                </h5>
                            </h5>
                            <h6 className="mb-1 text-center"> <span style={{ color: "#78A7FE", textShadow: '1px 1px 1px white' }}>Forgot</span>  <span style={{ color: "#78A7FE", textShadow: '1px 1px 1px white' }}>Password</span></h6>
                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%', position: "relative", }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>New Password</label>
                                    <input
                                        id="txtNewPassword"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtConfirmPassword'].focus()
                                            };
                                        }}
                                        type={showPassword.newPassword ? 'text' : 'password'}
                                        ref={ref => (inputrefs.current['txtNewPassword'] = ref)}
                                        className="form-control"
                                        autoComplete="off"
                                        placeholder='New Password'
                                        maxLength='20'
                                        name='newPassword'
                                        value={user.newPassword}
                                        onChange={(e) => setUser({ ...user, newPassword: e.target.value })}
                                    />
                                </div>
                                <span style={{ position: "absolute", left: "92%", bottom: "50%", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('newPassword')}>
                                    {showPassword.newPassword ? <FaEyeSlash style={{ color: "#CC9966" }} /> : <FaEye style={{ color: "#CC9966" }} />}
                                </span>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%', position: "relative", }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>Confirm Password</label>
                                    <input
                                        id="txtConfirmPassword"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleSubmit(e)
                                            };
                                        }}
                                        type={showPassword.confirmPassword ? 'text' : 'password'}
                                        ref={ref => (inputrefs.current['txtConfirmPassword'] = ref)}
                                        className="form-control"
                                        autoComplete="off"
                                        placeholder='Confirm Password'
                                        maxLength='20'
                                        name='confirmPassword'
                                        value={user.confirmPassword}
                                        onChange={(e) => setUser({ ...user, confirmPassword: e.target.value })}
                                    />
                                </div>
                                <span style={{ position: "absolute", left: "92%", bottom: "50%", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('confirmPassword')}>
                                    {showPassword.confirmPassword ? <FaEyeSlash style={{ color: "#CC9966" }} /> : <FaEye style={{ color: "#CC9966" }} />}
                                </span>
                            </div>
                            <div className="py-2 loading">
                                <button className='btn  w-100 login-btn loginhover' onClick={handleSubmit} >Submit</button>
                                {isLoading && (<BlurLoader />)}
                            </div>
                            <Link to='/login' className="mt-2" style={{ fontSize: '13px', position: "relative", left: "70%", }}
                               
                            > <IoMdArrowRoundBack />Back To Login</Link>

                          
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}





